<script setup lang="ts">
import { useNavigationStore } from '../../stores/navigationStore'
import { useVehicleStore } from '../../stores/vehicleStore'
import type { CustomRmiLink } from '../../api/tecdocApi'
import ShortcutCard from './ShortcutCard.vue'

const emit = defineEmits<{
  (e: 'navigate', link: CustomRmiLink): void
  (e: 'add-clicked'): void
}>()

const navStore = useNavigationStore()
const vehicleStore = useVehicleStore()

async function removeLink(link: CustomRmiLink) {
  if (!confirm(`Fjerne "${link.label}"?`)) return
  try {
    await navStore.removeCustomRmiLink(
      link.categoryId,
      link.mainGroupId ?? null,
      link.subGroupId ?? null,
    )
  } catch (err) {
    alert('Kunne ikke slette: ' + ((err as Error).message || ''))
  }
}
</script>

<template>
  <div
    v-if="navStore.customRmiLinksForCurrentScope.length > 0 || navStore.canEditCategories"
    class="custom-rmi-bar"
  >
    <div class="custom-rmi-bar__grid">
      <ShortcutCard
        v-for="link in navStore.customRmiLinksForCurrentScope"
        :key="`${link.categoryId}-${link.mainGroupId ?? ''}-${link.subGroupId ?? ''}`"
        :link="link"
        :editable="navStore.canEditCategories"
        @click="emit('navigate', link)"
        @remove="removeLink(link)"
      />

      <button
        v-if="navStore.canEditCategories"
        type="button"
        class="custom-rmi-bar__add-card"
        :disabled="!vehicleStore.carDetails?.carId && !vehicleStore.carId"
        @click="emit('add-clicked')"
      >
        <span class="custom-rmi-bar__add-icon">+</span>
        <span class="custom-rmi-bar__add-label">Legg til</span>
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.custom-rmi-bar {
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 0.625rem;
  }

  &__add-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    width: 100%;
    min-height: 96px;
    padding: 0.75rem 0.5rem;
    background: white;
    color: #002868;
    border: 2px dashed #002868;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;

    &:hover:not(:disabled) {
      background: #e0ecff;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  &__add-icon {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1;
  }

  &__add-label {
    font-size: 0.78rem;
    font-weight: 600;
  }
}
</style>
